var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"home section-bg"},[_c('div',{staticClass:"container"},[(_vm.isLoading)?_c('b-icon',{attrs:{"icon":"three-dots","animation":"cylon","font-scale":"4"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }